import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(24px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${theme.lightBlack};
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalPanel = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  width: 420px;
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  animation: ${slideUp} 0.25s ease-out;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  font-weight: ${fontWeight.semiBold};
  color: ${theme.greyText3};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FieldInput = styled.input`
  border: 1px solid ${theme.lightGrey};
  border-radius: 8px;
  padding: 12px 14px;
  font-size: ${fontSize.font14};
  color: ${theme.blackText};
  outline: none;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: ${theme.lightGreyText};
  }

  &:focus {
    border-color: ${theme.blueText};
    box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.12);
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 8px;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.whiteText};
  background: ${theme.blueGradient};
  cursor: pointer;
  margin-top: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }
`;
